import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=06fe93aa&"
import script from "./ModelDetails.vue?vue&type=script&lang=ts&"
export * from "./ModelDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports